import { render, staticRenderFns } from "./addComponent.vue?vue&type=template&id=5dc3d11c&scoped=true&"
import script from "./addComponent.vue?vue&type=script&lang=js&"
export * from "./addComponent.vue?vue&type=script&lang=js&"
import style0 from "./addComponent.vue?vue&type=style&index=0&id=5dc3d11c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3d11c",
  null
  
)

export default component.exports